// Backend communication layer. UI components never call axios directly.
import { api, authHeaders } from "@/lib/api";

const statusFormData = (status) => {
  const fd = new FormData();
  fd.append("status", status);
  return fd;
};

export const casesApi = {
  list: (params) => api.get("/cases", { params }).then((r) => r.data),
  get: (id) => api.get(`/cases/${id}`).then((r) => r.data),
  municipalities: () => api.get("/municipalities").then((r) => r.data),
  create: (formData) =>
    api
      .post("/cases", formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 60000 })
      .then((r) => r.data),
  withdraw: (id, phone) => api.post(`/cases/${id}/withdraw`, { phone }).then((r) => r.data),
  reportAbuse: (id, reason) => api.post(`/cases/${id}/report-abuse`, { reason }).then((r) => r.data),
};

export const claimsApi = {
  create: (caseId, body) => api.post(`/cases/${caseId}/claim`, body).then((r) => r.data),
};

export const handoffsApi = {
  list: (caseId) => api.get(`/cases/${caseId}/handoffs`).then((r) => r.data),
  create: (caseId, formData) =>
    api.post(`/cases/${caseId}/handoffs`, formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 60000 }).then((r) => r.data),
};

export const otpApi = {
  request: (phone) => api.post("/otp/request", { phone }).then((r) => r.data),
};

export const postsApi = {
  list: (params) => api.get("/posts", { params }).then((r) => r.data),
  create: (formData) =>
    api.post("/posts", formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 30000 }).then((r) => r.data),
  reportAbuse: (id, reason) => api.post(`/posts/${id}/report-abuse`, { reason }).then((r) => r.data),
};

export const seekersApi = {
  list: (params) => api.get("/seekers", { params }).then((r) => r.data),
  get: (id) => api.get(`/seekers/${id}`).then((r) => r.data),
  create: (formData) =>
    api
      .post("/seekers", formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 90000 })
      .then((r) => r.data),
  withdraw: (id, phone) => api.post(`/seekers/${id}/withdraw`, { phone }).then((r) => r.data),
  reportAbuse: (id, reason) => api.post(`/seekers/${id}/report-abuse`, { reason }).then((r) => r.data),
};

export const adminApi = {
  firebaseLogin: (idToken) => api.post("/admin/firebase-login", { id_token: idToken }).then((r) => r.data),
  requestOtp: (phone, secret) => api.post("/admin/request-otp", { phone, secret }).then((r) => r.data),
  verifyOtp: (phone, code) => api.post("/admin/verify-otp", { phone, code }).then((r) => r.data),
  stats: () => api.get("/admin/stats", authHeaders()).then((r) => r.data),
  claims: (status) =>
    api.get("/admin/claims", { ...authHeaders(), params: status ? { status } : {} }).then((r) => r.data),
  updateClaim: (id, status) => api.patch(`/admin/claims/${id}`, statusFormData(status), authHeaders()).then((r) => r.data),
  markCaseStatus: (id, status) =>
    api.patch(`/admin/cases/${id}/status`, statusFormData(status), authHeaders()).then((r) => r.data),
  setCaseVisibility: (id, hidden) => {
    const fd = new FormData(); fd.append("hidden", hidden);
    return api.patch(`/admin/cases/${id}/visibility`, fd, authHeaders()).then((r) => r.data);
  },
  setSeekerVisibility: (id, hidden) => {
    const fd = new FormData(); fd.append("hidden", hidden);
    return api.patch(`/admin/seekers/${id}/visibility`, fd, authHeaders()).then((r) => r.data);
  },
  posts: () => api.get("/admin/posts", authHeaders()).then((r) => r.data),
  setPostVisibility: (id, hidden) => {
    const fd = new FormData(); fd.append("hidden", hidden);
    return api.patch(`/admin/posts/${id}/visibility`, fd, authHeaders()).then((r) => r.data);
  },
  seekers: () => api.get("/admin/seekers", authHeaders()).then((r) => r.data),
  markSeeker: (id, status) =>
    api.patch(`/admin/seekers/${id}/status`, statusFormData(status), authHeaders()).then((r) => r.data),
  matches: () => api.get("/admin/matches", authHeaders()).then((r) => r.data),
  abuseReports: (status) =>
    api.get("/admin/abuse-reports", { ...authHeaders(), params: status ? { status } : {} }).then((r) => r.data),
  resolveAbuse: (id, status) => api.patch(`/admin/abuse-reports/${id}`, statusFormData(status), authHeaders()).then((r) => r.data),
};
